'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _recipes = require('redux/modules/recipes');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Recipe = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, recipe: state.recipes.recipe };
}, // connecting to the reducers, getting states
{ changeRecipe: _recipes.changeRecipe } // function we want to use from the module in redux
), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Recipe, _Component);

  function Recipe() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Recipe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Recipe.__proto__ || (0, _getPrototypeOf2.default)(Recipe)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      recipeItems: [{
        id: 0,
        title: 'Magnificent Make-Ahead Mini-Frittatas',
        component: _react2.default.createElement(_components.Frittatas, null)
      }, {
        id: 1,
        title: 'Pizza People',
        component: _react2.default.createElement(_components.Pizza, null)
      }, {
        id: 2,
        title: 'Fantastically Flexible Fruit Skewers',
        component: _react2.default.createElement(_components.Skewers, null)
      }, {
        id: 3,
        title: 'Beautiful Banana and Berry Smoothies',
        component: _react2.default.createElement(_components.Smoothies, null)
      }, {
        id: 4,
        title: 'Cheesy Chicken Meatballs',
        component: _react2.default.createElement(_components.Chicken, null)
      }]
    }, _this.handleTaskClick = function (item, event) {
      event.preventDefault();

      // we want to deselect all items
      // and select our current item
      var items = _this.state.recipeItems;
      for (var it in items) {
        if (items[it].id === item.id) {
          _this.props.changeRecipe(item.id);
          continue;
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Recipe, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var recipeItems = this.state.recipeItems;

      var style = require('./Recipe.scss');

      return _react2.default.createElement(
        'div',
        { className: style.recipesPage },
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 2, sm: 3, xs: 2, className: style.sidebar },
          _react2.default.createElement(
            'h3',
            null,
            'Recipes'
          ),
          _react2.default.createElement(
            ReactBootstrap.ListGroup,
            null,
            recipeItems.map(function (item) {
              return _react2.default.createElement(
                ReactBootstrap.ListGroupItem,
                { className: style.borderless, onClick: _this2.handleTaskClick.bind(_this2, item),
                  active: _this2.props.recipe === item.id },
                _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(ReactBootstrap.Col, { md: 1, sm: 1, xs: 1 }),
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 11, sm: 11, xs: 11 },
                    item.title
                  )
                )
              );
            })
          )
        ),
        _react2.default.createElement(ReactBootstrap.Col, { md: 2, sm: 3, xs: 2 }),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 10, sm: 9, xs: 9 },
          recipeItems.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              null,
              _this2.props.recipe === index && item.component
            );
          })
        )
      );
    }
  }]);
  return Recipe;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  recipe: _propTypes2.default.number,
  changeRecipe: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Recipe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Recipe/Recipe.js
// module id = 1285
// module chunks = 0